<template>
  <div>
    <div class="flex-end">
      <el-badge>
        <el-button class="mr10" type="primary" @click="CSVexport()">
          Export CSV
        </el-button>
      </el-badge>
      <Filters />
    </div>
    <h2>
      Number of channels: <span>{{ channels.total }}</span>
    </h2>
    <el-table
      :data="channels.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"
      class="w100"
      stripe
      v-loading="loading"
    >
      <el-table-column label="Name" prop="name" sortable>
        <template slot-scope="props">
          <a
            :href="`https://youtube.com/channel/${props.row.channel}`"
            target="_blank"
          >
            {{ props.row.name }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="Email" prop="email" sortable></el-table-column>
      <el-table-column
        label="Country"
        prop="country"
        sortable
      ></el-table-column>
      <el-table-column
        label="Subscribers"
        prop="subscribers"
        sortable
        :formatter="commaNumTable"
      ></el-table-column>
      <el-table-column
        label="Views"
        prop="views"
        sortable
        :formatter="commaNumTable"
      ></el-table-column>
      <el-table-column
        label="Number of videos"
        prop="videos"
      ></el-table-column>
      <el-table-column
        label="Number of categories"
        prop="categories"
        sortable
      ></el-table-column>
      <el-table-column label="VC Status" prop="vc_approved" sortable>
        <template slot-scope="props">
          <el-tag v-if="props.row.vc_approved === 0" type="info">
            No application
          </el-tag>
          <el-tag v-if="props.row.vc_approved === 1" type="success">
            Approved
          </el-tag>
          <el-tag v-if="props.row.vc_approved === 2" type="danger">
            Rejected
          </el-tag>
          <el-tag v-if="props.row.vc_approved === 3" type="primary">
            Waiting for approval
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Tier" prop="tier" sortable="custom">
        <template slot-scope="props">
          <el-tag :type="tierType(props.row.tier)">
            {{ tierName(props.row.tier) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right">
        <template slot-scope="props">
          <el-tooltip content="Show charts" placement="left">
            <el-button
              type="success"
              circle
              size="small"
              icon="el-icon-s-data"
              @click="readChannelChartData(props.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="channels.current_page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="channels.total"
    ></el-pagination>
    <el-dialog
      :title="channel_chart_name"
      :visible.sync="dialog_visible"
      width="75%"
      top="7vh"
    >
      <el-tabs :tab-position="subTabsPosition" v-model="activeName">
        <el-col :span="24">
          <el-divider content-position="left">Views</el-divider>
        </el-col>
        <el-col id="vid" :span="24" :lg="12">
          <GChart
            type="LineChart"
            :data="channel_chart_views"
            :options="LineChartSett"
          />
        </el-col>
        <el-col id="vid" :span="24" :lg="12">
          <GChart
            type="LineChart"
            :data="channel_chart_subscribers"
            :options="LineChartSett"
          />
        </el-col>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { GChart } from 'vue-google-charts'
import Filters from './Filters'

export default {
  components: {
    GChart,
    Filters
  },

  data() {
    return {
      channel_chart_name: '',
      subTabsPosition: 'top',
      activeName: 'first',
      dialog_visible: false
    }
  },

  computed: {
    ...mapState('reportsChannels', [
      'loading',
      'date_range',
      'page',
      'page_size',
      'order_column',
      'order_type',
      'channels',
      'channel_chart',
      'LineChartSett'
    ]),

    ...mapGetters('auth', ['admin_role']),
    ...mapGetters('reportsChannels', [
      'channel_chart_views',
      'channel_chart_subscribers'
    ])
  },

  methods: {
    ...mapActions('reportsChannels', ['readChannelChart', 'readChannels', 'CSVexport']),
    ...mapMutations('reportsChannels', [
      'setDateRange',
      'setPage',
      'setPageSize',
      'setOrdering'
    ]),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.readChannels()
    },
    currentChange(page) {
      this.setPage(page)
      this.readChannels()
    },
    readChannelChartData(data) {
      this.dialog_visible = true
      this.channel_chart_name = `${data.name}`
      this.readChannelChart({
        id: data.channel,
        start: this.date_range[0],
        end: this.date_range[1]
      })
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.readChannels()
    }
  }
}
</script>

<style scoped>
h1 {
  text-align: left;
  margin: 4rem 3rem 4rem;
  font-weight: 200;
  font-size: 1.7rem;
}

h2 {
  color: #3e3e3e;
  font-size: 1.6rem;
  text-align: left;
  font-weight: 100;
  margin: 1.2rem 0.5rem 2rem;
}
</style>
